import { ContactForm } from "./ContactForm";
import { ContactInfo } from "./ContactInfo";

export function Contact() {
    return (
        <section className="relative overflow-hidden bg-web-background lg:px-24 md:px-12 px-6 md:py-20 py-16">
            {/* Background glow */}
            <div className="absolute inset-0 bg-web-radial-glow" />

            {/* Green blur ball */}
            <div className="absolute left-1/2 top-1/3 h-[40vw] w-[40vw] min-h-[250px] min-w-[250px] max-h-[500px] max-w-[500px] -translate-x-1/2 rounded-full bg-web-primary/20 blur-[140px]" />

            <div className="relative z-10 flex flex-col items-center text-center">
                <div className="mb-4 flex items-center gap-3">
                    <span className="text-xs font-medium uppercase tracking-[0.3em] text-web-primary">
                        Get in touch
                    </span>
                </div>

                <h2 className="max-w-5xl text-4xl font-bold leading-tight text-white md:text-6xl">
                    Let's{" "}
                    <span className="text-web-primary">
                        talk shop.
                    </span>
                </h2>

                <p className="mt-4 max-w-3xl text-base leading-7 text-white">
                    Sales questions, integration help, or feedback on the API — we read every message.
                </p>
            </div>

            <div className="mx-auto mt-20 grid max-w-7xl gap-6 lg:grid-cols-[2fr_3fr]">
                <ContactInfo />
                <ContactForm />
            </div>
        </section>
    );
}
